export default __webpack_public_path__ + "static/media/SoilSense-Dashboard.667ee4be.png";